'use client'

import { useEffect, useState } from 'react'
import s from './content.module.scss'

type Props = {
  content?: string
}

export const ContentV3 = ({ content }: Props) => {
  const embedValue = content ?? 'Empty..'
  const [decodedHtml, setDecodedHtml] = useState(embedValue)
  const [hasBeenDecoded, setHasBeenDecoded] = useState(false)

  useEffect(() => {
    const decodeHtml = (encodedString: string) => {
      const parser = new DOMParser()
      const doc = parser.parseFromString(encodedString, 'text/html')
      return doc.body.innerHTML || ''
    }

    const blockContentPurified = embedValue.split('{CCM:BASE_URL}').join('')

    // legacy article blocks containe non-escaped <blockquote and <iframe tags, so we don't decode them
    if (embedValue.includes('<blockquote') || embedValue.includes('iframe')) {
      setDecodedHtml(blockContentPurified)
      return
    }

    if (!Array.isArray(blockContentPurified)) {
      setDecodedHtml(decodeHtml(blockContentPurified))
      setHasBeenDecoded(true)
    }
  }, [content])

  useEffect(() => {
    if (typeof window !== 'undefined' && hasBeenDecoded) {
      setTimeout(() => {
        window.instgrm?.Embeds?.process()
      }, 100)
    }
  }, [hasBeenDecoded])

  return (
    <section
      className={s.embedContent}
      data-empty={!content}
      dangerouslySetInnerHTML={{ __html: decodedHtml }}
    />
  )
}
